import React from 'react';
import { useSelector } from 'react-redux';
import { getMediaPath } from '../../../../app/functions';
import './index.scss';

const ReasonsSection = () => {
    const insurancePage = useSelector((store) => store.insurancePage);

    const reasonsData = [...insurancePage?.reasons] || [];

    reasonsData.sort(
        (a, b) => a['order_num'] - b['order_num']
    );

    return (
        <section className="reasons-section">
            <h2 className="reasons-title">
                {insurancePage?.general?.reasons_title}
            </h2>

            <ul className="reasons-list">
                {reasonsData.map((reasonData) => (
                    <li key={reasonData?.id} className="reason-container">
                        <img
                            src={getMediaPath(reasonData?.icon_path)}
                            alt={reasonData?.title}
                            className="reason-icon"
                        />

                        <h3 className="reason-title">
                            {reasonData?.title}
                        </h3>

                        <p className="reason-description">
                            {reasonData?.description}
                        </p>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default ReasonsSection;
